import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnexoService } from '../../../services/anexo.service';
import { AnexoAvanceProcesalResponseDto } from '../../../dto/anexo/anexo.dto';
import { TableColumn } from '../../../dto/util/table-column';
import { AvanceProcesalDto } from '../../../dto/avance-procesal/avance-procesal.dto';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-anexos-avance-procesal',
  templateUrl: './anexos-avance-procesal.component.html',
  styleUrl: './anexos-avance-procesal.component.scss',
})
export class AnexosAvanceProcesalComponent implements OnInit {
  avanceProcesalId = 0;
  anexosList: AnexoAvanceProcesalResponseDto[] = [];
  avanceProcesalItem: AvanceProcesalDto = {} as AvanceProcesalDto;

  columns: TableColumn[] = [];
  pageSize = 5;
  totalPages = 0;
  currentPage = 1;

  // Multilenguaje
  tableText: any = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private anexoService: AnexoService,
    private translate: TranslateService
  ) {
    this.route.params.subscribe(params => {
      this.avanceProcesalId = params['avanceProcesalId'];
    });
    // Multilenguaje
    this.translate.stream('anexos.avance-procesal').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      this._initColumns();
    });
  }

  ngOnInit() {
    this.avanceProcesalItem = history.state.item;
    this._getAnexosAvanceProcesal(this.avanceProcesalId);
  }

  private _getAnexosAvanceProcesal(avanceProcesalId: number) {
    this.anexoService
      .getAnexosByAvanceProcesalId(avanceProcesalId)
      .subscribe(response => {
        this.anexosList = response.map(anexo => ({
          ...anexo,
          tamano: this._convertBytes(anexo.tamano),
        }));
        this._initColumns();
      });
  }

  private _convertBytes(bytes: string | number): string {
    const bytesNumber = typeof bytes === 'string' ? parseFloat(bytes) : bytes;
    if (bytesNumber < 1024 * 1024) {
      return `${(bytesNumber / 1024).toFixed(2)} KB`;
    } else {
      return `${(bytesNumber / (1024 * 1024)).toFixed(2)} MB`;
    }
  }

  private _initColumns() {
    this.columns = [
      {
        field: 'nombre_archivo',
        title: this.tableText['nombre'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'tamano',
        title: this.tableText['tamanio'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'extension',
        title: this.tableText['tipo'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
  }
}
